(function (root, factory) {
    'use strict';
    if (typeof module === 'object' && module.exports) module.exports = factory();
    else root.PewniakiUdostepnianie = factory();
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
    'use strict';

    var PROVIDERS = Object.freeze({
        facebook: function (payload) {
            return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(payload.url);
        },
        whatsapp: function (payload) {
            return 'https://wa.me/?text=' + encodeURIComponent(joinText(payload));
        },
        x: function (payload) {
            return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(payload.title || '') +
                '&url=' + encodeURIComponent(payload.url);
        }
    });

    function cleanPayload(payload) {
        payload = payload || {};
        return {
            url: String(payload.url || '').trim(),
            title: String(payload.title || '').trim(),
            text: String(payload.text || '').trim()
        };
    }

    function joinText(payload) {
        return [payload.title, payload.text, payload.url].filter(Boolean).join('\n');
    }

    function providerUrl(provider, payload) {
        payload = cleanPayload(payload);
        if (!payload.url || !Object.prototype.hasOwnProperty.call(PROVIDERS, provider)) return null;
        return PROVIDERS[provider](payload);
    }

    function copyText(text) {
        if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
            return Promise.reject(new Error('clipboard-unavailable'));
        }
        return navigator.clipboard.writeText(String(text));
    }

    function open(provider, rawPayload) {
        var payload = cleanPayload(rawPayload);
        if (!payload.url) return Promise.reject(new Error('missing-url'));

        if (provider === 'instagram') {
            if (navigator.share) {
                return navigator.share({title: payload.title, text: payload.text, url: payload.url})
                    .then(function () { return {mode: 'native'}; });
            }
            return copyText(payload.url).then(function () { return {mode: 'copied'}; });
        }

        var url = providerUrl(provider, payload);
        if (!url) return Promise.reject(new Error('unknown-provider'));
        var popup = window.open(url, '_blank', 'noopener,noreferrer');
        // With noopener Chromium returns null even for an opened window.
        // Keep opener/referrer isolation; null does not prove popup blocking.
        if (popup) popup.opener = null;
        return Promise.resolve({mode: 'popup'});
    }

    function bind(group, options) {
        if (!group || group.dataset.shareBound === '1') return;
        options = options || {};
        group.dataset.shareBound = '1';
        group.addEventListener('click', function (event) {
            var button = event.target.closest('[data-share-provider]');
            if (!button || !group.contains(button)) return;
            var provider = button.dataset.shareProvider;
            var payload = typeof options.payload === 'function' ? options.payload() : options.payload;
            open(provider, payload).then(function (result) {
                if (typeof options.status === 'function') options.status('success', provider, result.mode);
            }, function (error) {
                if (error && error.name === 'AbortError') return;
                if (typeof options.status === 'function') options.status('error', provider, error && error.message);
            });
        });
    }

    return {providers: Object.keys(PROVIDERS).concat(['instagram']), providerUrl: providerUrl, copyText: copyText, open: open, bind: bind};
}));
